import { useQuery } from "@apollo/react-hooks";
import { GetApplicantDetails } from "./queries";

export function useApplicantDetails({ applicantId, opportunityId }) {
  const { data } = useQuery(GetApplicantDetails, {
    variables: { id: applicantId, opportunityId },
    skip: !applicantId
  });

  const applicant = data && data.accounts && data.accounts[0];
  const firstApplicationEvent =
    applicant &&
    applicant.applicationEvents.filter((event) => event.status == "Applied")[0];
  return {
    applicant: data && data.accounts && data.accounts[0],
    firstApplicationEvent
  };
}
